<template>
  <div class="s-contact__failed">
    <div class="s-contact__failed__title">
      {{ tr("contact_form.failed.title") }}
    </div>
    <p class="s-contact__failed__text">{{ tr("contact_form.failed.text") }}</p>
  </div>
</template>

<script setup lang="ts">
import { useI18nContactForm } from "@solvari/translations";

const { tr } = useI18nContactForm();
</script>

<style lang="postcss">
.s-contact__failed {
  @apply mt-6 rounded border border-danger-200 bg-danger-100 p-8;

  &__title {
    @apply mb-4 font-secondary text-2xl font-bold text-danger-600;
  }

  &__text {
    @apply text-gray-800;
  }
}
</style>
